export default __webpack_public_path__ + "static/media/InfoIcon.67c388b5.svg";